import React from "react";
import { FloatingForm } from "../../../../components/common/Converter";
import CardView from "../../../../components/common/CardView";
import FormFactory from "../../../../components/FormFactory";
import BaseFormPage from "../../../../base/BaseFormPage";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import Hierarchy from "../../../../components/common/Hierarchy";

export default class UpdateLogSchedule extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
    };
  }

  getCollectionName() {
    return "schedule_template";
  }
  componentDidMount() {
    return;
  }

  async handleUpdateSchedule() {
    const { employee, closeDialog } = this.props;
    const { object } = this.state;
    console.log("OB: ", object);

    const biometricLogs = await findObjectUseCase().execute("biometric_logs", {
      where: {
        pin: String(employee?.biometricId),
        timestamp: {
          $gte: `${object.scheduleDate[0]}T00:00:00.000Z`,
          $lte: `${object.scheduleDate[1]}T23:59:59.999Z`,
        },
      },
    });
    console.log("biometricLogs: ", biometricLogs);
    try {
      if (biometricLogs.length === 0) return;
      for (const log of biometricLogs) {
        const updateLog = {
          id: log.id,
          scheduleUpdate: object?.selectedSchedule || null,
          twentyFourSeven: object?.twentyFourSeven || "",
        };
        try {
          await upsertUseCase().execute("biometric_logs", updateLog);
        } catch (e) {
          throw new Error(e.message || e);
        }
      }
      this.hideProgressDialog();
      closeDialog();
      this.showSuccess("Successfully updated");
    } catch (e) {
      this.hideProgressDialog();
      closeDialog();
      this.showError(e.message || e);
      console.error(e.message || e);
    }
  }

  formatForDateInput(date) {
    if (typeof date === "string") {
      return new Date(date).toISOString().split("T")[0];
    }
    return date.toISOString().split("T")[0];
  }

  handleObjectChange(hierarchy) {
    let hierarchyFilter = {};
    const fieldMap = {
      region: "regions",
      office: "offices",
      division: "divisions",
      section: "sections",
      unit: "units",
      cluster: "plantilla",
    };

    Object.entries(hierarchy).forEach(([key, value]) => {
      const dbField = fieldMap[key];

      if (!dbField) return; // skip unknown keys

      if (value && value.length) {
        // hierarchyFilter[dbField] = { $in: [value] };
        hierarchyFilter = { [dbField]: { $in: [value] } };
      } else {
        delete hierarchyFilter[dbField];
      }
    });

    this.setState({ hierarchyFilter });
  }

  render() {
    const { minDate, maxDate, closeDialog } = this.props;
    const { object, hierarchyFilter } = this.state;
    // console.log("OB: ", hierarchyFilter);
    const schema = {
      collection: this.getCollectionName(),
      fields: {
        scheduleDate: {
          type: "Array",
          _type: "DateRange",
          label: "Date covered",
          required: true,
          disabledDate: (current) => {
            if (!current) return false;
            const min = minDate ? new Date(minDate) : null;
            const max = maxDate ? new Date(maxDate) : null;
            if (min) min.setHours(0, 0, 0, 0);
            if (max) max.setHours(23, 59, 59, 999);
            if (min && current < min) return true;
            if (max && current > max) return true;
            return false;
          },
        },
        selectedSchedule: {
          type: "Pointer",
          required: true,
          label: "New Assigned Schedule",
          target: "schedule_template",
          where: hierarchyFilter,
          // where: {
          //   sections: {
          //     $in: ["20862f43-135d-4c4d-a080-a5f0d97f18c6"],
          //   },
          // },
          keys: [
            "name",
            "scheduleArray",
            "selectedOption",
            "sequence",
            "startingDate",
          ],
        },
        twentyFourSeven: {
          type: "String",
          _type: "Enum",
          label: "Duty Hours",
          required: true,
          options: ["9 Hours", "10.5 Hours", "12 Hours"],
        },
      },
    };
    return (
      <FloatingForm width={"50rem"}>
        <CardView>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.showProgressDialog();
              this.handleUpdateSchedule();
            }}
          >
            <div className="p-2">
              <div className="row">
                <h4>Update Schedule</h4>
                <hr />
                <div className="p-3">
                  <div className="row border rounded p-2 mb-3">
                    <label>Filter schedule</label>
                    <Hierarchy
                      className="col-lg-4 p-1 mb-3"
                      object={object}
                      handleObjectChange={this.handleObjectChange.bind(this)}
                    />
                  </div>
                  <FormFactory
                    className="pb-3"
                    schema={schema}
                    object={object}
                    onChange={(value, field) =>
                      this.setState((prevState) => ({
                        object: { ...prevState.object, [field]: value },
                      }))
                    }
                  />
                </div>
                <hr />
              </div>

              <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
                <button
                  className="btn btn-light fs-sm"
                  type="button"
                  onClick={() => closeDialog()}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" type="submit">
                  Confirm
                </button>
              </div>
            </div>
          </form>
        </CardView>
      </FloatingForm>
    );
  }
}
